import convertOrderItemsToCartItems from "./convertOrderItemsToCartItems"
import convertOrderCombosToCartCombos from "./convertOrderCombosToCartCombos"
import validateCartContents from "./validateCartContents"

const checkIsOrderEditable = async (order) => {
  const previousOrderItems =
    convertOrderItemsToCartItems(
      order.items
    )

  const previousOrderCombos =
    convertOrderCombosToCartCombos(order.items)

  const previousOrder = {
    items: previousOrderItems,
    combos: previousOrderCombos
  }

  const problematicItems =
    await validateCartContents(
      previousOrderItems,
      previousOrderCombos,
      previousOrder
    )

  return problematicItems.length === 0
}

export default checkIsOrderEditable